<div class="buy-again">
  <div class="divider" *ngIf="!isMobile"></div>
  <a
    [href]="user ? buyAgainLink : validateEmailLink"
    [ngClass]="{ 'buy-again-mobile-button': isMobile, 'buy-again-button': !isMobile }"
    [mmTestTarget]="'navigation-buy-again'"
    type="button"
    (click)="hideMenuAndSendGABuyAgainEvent()"
  >
    {{ 'HEADER.ALL_PAGES.HEADER.BUY_AGAIN_BUTTON' | translate }}
  </a>
</div>
